$(document).ready(function() {
  $('.inventory-category').on('change', function() {
    $('.inventory-category-options').addClass('d-none');
    $('.inventory-category-options select#inventory_event_id').removeAttr('required');

    var inventory_category_id = $(this).val();
    $.ajax({
      type: 'GET',
      url: `/admin/inventories/inventory_category_id/${inventory_category_id}/reload_event_options`,
      dataType: 'JSON',
      success: function (result) {
        $('.select-event-options').html('');
        $('.select-event-options').append('<option value>' + I18n.t('actions.select', { item: I18n.t('global.events') }) + '</option>');
        $('#set-variant-button').removeClass('d-none');

        if (result.events.length > 0) {
          $.each(result.events, function(id, elm) {
            $('.select-event-options').append('<option value="'+ elm.id +'">'+ elm.name +'</option>');
          })

          $('.inventory-category-options').removeClass('d-none');
          $('.inventory-category-options select#inventory_event_id').attr('required', true);
          $('.select-event-options').select2();
          $('#set-variant-button').addClass('d-none');
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(I18n.t('global.alerts.something_went_wrong'));
      }
    })
  })
})